import { Currency } from "@evennt-tech/api-v2-core";
import { BillingDetails } from "store/exhibitors/cartStepper/helper";

export enum PaymentMethodType {
  notSelected = "not_selected",
  cardPayment = "card_payment",
  bankTransfer = "bank_transfer",
  idealPayment = "ideal",
}

export type CardPayment = {
  type: PaymentMethodType.cardPayment;
  amount: number;
  paymentType?: "automatic" | "manual";
  description: string;
  currency: Currency;
  showId: string;
  orderId: string;
  country: string;
  showName: string;
  showStartDate: string;
};

export type BankTransfer = Omit<CardPayment, "type"> & {
  type: PaymentMethodType.bankTransfer;
  customerId: string;
  invoiceId: string;
  country: string;
  billingDetails: Pick<
    BillingDetails,
    "postCode" | "vat" | "address" | "contact" | "contactEmail"
  > & { contactPhoneNumber: string };
};

export type IdealPayment = Omit<CardPayment, "type"> & {
  type: PaymentMethodType.idealPayment;
  currency: Currency.eur;
  country: string;
};

type PaymentMethod = CardPayment | BankTransfer | IdealPayment;

export default PaymentMethod;
